var icons = {
	show: '<svg class="u-icon"><use xlink:href="' + patch.stylesheet_directory_uri + '/assets/img/icons.svg#show"></use></svg>',
	hide: '<svg class="u-icon"><use xlink:href="' + patch.stylesheet_directory_uri + '/assets/img/icons.svg#hide"></use></svg>',
};

document.addEventListener('DOMContentLoaded', function() {

	svg4everybody();

});
